import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { makeStyles, Typography, Card } from '@material-ui/core';

import { UsersGraph } from './UsersGraph';
import { SessionsGraph } from './SessionsGraph';
import { PostsGraph } from './PostsGraph';
import { SalesGraph } from './SalesGraph';
import { InteractionsGraph } from './InteractionsGraph';
import { WishlistGraph } from './WishlistGraph';

export function Panels() {
	const { sales, active, merchants, merchantId, statistics } = useSelector(
		(state) => ({
			...state.dashboard,
			merchants: state.merchants.merchants,
			merchantId: state.merchants.filter.merchantId,
		}),
		shallowEqual
	);
	const classes = useStyles();

	const panels = {
		Users: () => <UsersGraph data={statistics} />,
		Sessions: () => <SessionsGraph data={statistics} merchantId={merchantId} merchants={merchants} />,
		Posts: () => <PostsGraph data={statistics} />,
		Sales: () => <SalesGraph data={sales} merchantId={merchantId} merchants={merchants} />,
		Interactions: () => <InteractionsGraph data={statistics} />,
		Wishlist: () => <WishlistGraph data={statistics} />,
	};

	return (
		<Card className={classes.panel}>
			<Typography variant='h4'>{active}</Typography>
			{panels[active]()}
		</Card>
	);
}

const useStyles = makeStyles(() => ({
	panel: {
		boxShadow: 'none !important',
		padding: 20,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 10,
		borderBottomLeftRadius: 10,
		width: '100%',
		minHeight: 500,
		overflow: 'visible',
	},
}));
